export const cashRegisterOperationQueryKeys = {
  id: 'id',
  name: 'category_name',
  parent: {
    id: 'parent_id',
    name: 'parent_name',
  },
  createdAt: 'created_at',
};
